import React from 'react'
import {
  AddressFields,
  AmountAndRecurringSelection,
  CompanyFields,
  GeneralError,
  GiftInfo,
  HeroImage,
  HolderFields,
  HolderHeadline,
  MatchingFundBanner,
  MessageField,
  MonthlyMatchingFundBanner,
  OfflineMessage,
  PaymentMethodError,
  PaymentMethodSelection,
  PlatformNewsletterCheckbox,
  StripeCCFields,
  StripeSEPADebitFields,
  SubmitButton,
  Terms,
  TrustLogos,
} from '../shared'
import { CodonationBox } from './codonation_box/codonation_box'
import { Debug } from 'donate/debug'
import { DonationFormCaptcha } from 'donate/shared/donation_form_captcha'
import { Form, connect } from 'formik'
import { FormProps, FormValues } from 'donate/types'
import { I18nHtml } from 'shared'
import { MatchingEventNotice } from 'ppp/matching_event_notice/matching_event_notice'
import { PlatformFormComp } from './types'
import { ProhibitedNotice } from './prohibited_notice'
import { Sum } from './sum'

//TODO: Improve types
export const PlatformForm: PlatformFormComp = connect<FormProps, FormValues>(({ display, config, formik }) => {
  const addressRequired = formik.values._company_donation || formik.values.payment_method == 'paydirekt'

  if (config.donationsProhibited) {
    return (
      <WrappingDivs>
        <HeroImage {...display} linked />
        <ProhibitedNotice backHref={display.receiverUrl} />
      </WrappingDivs>
    )
  }

  return (
    <>
      <WrappingDivs>
        <HeroImage {...display} linked />

        {display.matchingEvent && (
          <div className="donate-form-notices">
            <MatchingEventNotice matchingEvent={display.matchingEvent} />
          </div>
        )}

        <Form>
          <div className="donate-form-content generic-popover-constraints">
            <GeneralError />
            <OfflineMessage />

            <AmountAndRecurringSelection />
            <MonthlyMatchingFundBanner config={config} />

            <MatchingFundBanner config={config} display={display} />

            <div className="form-fields">
              <PaymentMethodSelection />
              <HolderHeadline />
              <HolderFields />
              <CompanyFields />
              {addressRequired && <AddressFields required />}
              <MessageField config={config} />
              {!addressRequired && <AddressFieldToggle />}
              <StripeCCFields />
              <StripeSEPADebitFields />
              <PaymentMethodError />
              <CodonationBox config={config} formik={formik} display={display} />
              {config.showCodonation && <Sum />}
              <PlatformNewsletterCheckbox />
              <SubmitButton config={config} />
              {config.receiverType === 'Project' && <GiftInfo enabled={false} />}
              <Terms />
              <TrustLogos />
              <DonationFormCaptcha config={config} />
            </div>
          </div>
        </Form>
        <Debug />
      </WrappingDivs>
    </>
  )
})

const WrappingDivs = ({ children }: { children?: React.ReactNode }) => (
  <div className="donate-form platform-donations-new">
    <div className="bg-teal-500">
      <div className="container preserves-space-for-transparent-header">
        <div className="row">
          <div className="col-md-16 offset-md-4 wrapper">{children}</div>
        </div>
      </div>
    </div>
  </div>
)

export const AddressFieldToggle = connect<{}, FormValues>(({ formik }) => {
  const receiptDesired = formik.values.receipt_desired

  return (
    <div className="my-12">
      <label className="generic-custom-radio-field w-full mb-3" htmlFor="receiveReceipt">
        <input
          type="checkbox"
          id="receiveReceipt"
          onChange={() => {
            void formik.setFieldValue('receipt_desired', !receiptDesired)
            if (receiptDesired) {
              // if previously true, i.e. when hiding address fields
              void formik.setFieldValue('street', '')
              void formik.setFieldValue('zip', '')
              void formik.setFieldValue('city', '')
            }
            setTimeout(() => void formik.validateForm(), 200)
          }}
          checked={receiptDesired}
        />
        <span className="generic-custom-radio" />
        <I18nHtml i18nKey="donate.receipt_desired_html" />
      </label>
      {receiptDesired && <AddressFields required />}
    </div>
  )
})
